export default __webpack_public_path__ + "static/media/img_block_3.1732a186.svg";